import './styles/main.scss';

import { RouterProvider } from 'react-router-dom';
import { router } from './routes/routes';
import { useEffect } from "react";
import { useDispatch } from "react-redux";

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    registerServiceWorker();
  }, [])

  const registerServiceWorker = async () => {
    let newWorker;

    if('serviceWorker' in navigator) {
      await navigator.serviceWorker.register(`${process.env.PUBLIC_URL}/serviceWorker.js`, { scope: '/'})
      .then(reg => {
        console.log('Service Worker registered!');

        reg.addEventListener('updatefound', () => {
          // A wild service worker has appeared in reg.installing!
          newWorker = reg.installing;
          newWorker.addEventListener('statechange', () => {
            // Has network.state changed?
            switch (newWorker.state) {
              case 'installed':
                if (navigator.serviceWorker.controller) {
                  window.localStorage.setItem('version-update-needed', 'true');
                  dispatch({type: 'reload/set', payload: true});
                }
                // No update available
                break;
              default: return null;
            }
          });
        });
      })
      .catch((e) => {
        console.error(`Service Worker failed: ${e}`);
      });
      
      navigator.serviceWorker.ready.then((registration) => {
        console.log('Service Worker ready!');
      })
    }
  };

  return (
    <RouterProvider router={router} />  
  );
}

export default App;
